import React from 'react';
import { StockMovementContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { Displays, Inputs, Tables } from 'components';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import * as XLSX from 'xlsx';
import moment from 'moment';
import 'moment-timezone';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';

const TIME_ZONE = 'Asia/Bangkok';

const FILTER_FIELDS = [
  'reward_name',
  'reward_type',
  'action_type',
  'start_date',
  'end_date',
];

const RENDER_COUPON_TYPE = (type) => {
  switch (type) {
    case '1':
      return 'E-coupon';
    case '2':
      return 'Coupon';
    case '3':
      return 'Others';
    default:
      return '';
  }
};

const RENDER_ACTION_TYPE = (actionType) => {
  switch (actionType) {
    case '1':
      return 'เพิ่มสต็อก (ไฟล์ reward)';
    case '2':
      return 'เพิ่มสต็อก (ไฟล์ e-coupon)';
    case '3':
      return 'แก้ไขสต็อก (portal)';
    case '4':
      return 'สร้างของรางวัล (portal)';
    case '8':
      return 'ปรับยอดแลกให้ตรงประวัติ';
    case '9':
      return 'สต็อกหมด';
    default:
      return '';
  }
};

// แปลง query string ของ url เป็น state ของ filter (ใช้ตอนเข้าหน้าครั้งแรก / กด refresh)
const parseUrlQuery = (search) => {
  const searchParams = new URLSearchParams(search || '');
  const currentPage = Number(searchParams.get('page')) || 1;
  let filterValues = {};
  FILTER_FIELDS.forEach((key) => {
    filterValues[key] = searchParams.get(key) || '';
  });
  Array.from(searchParams.keys()).forEach((key) => {
    if (FILTER_FIELDS.indexOf(key) === -1 || !searchParams.get(key)) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : '',
    filterValues,
    currentPage,
  };
};

class StockMovementContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    data: [],
    filterKey: 0,
    ...parseUrlQuery(this.props.router.location.search),
  };

  componentDidMount() {
    const { filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    this.handleJoinQuery(filterQuery, currentPage);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_REWARD_STOCK_HISTORY_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    } else {
      this.setState({ isLoading: false });
    }
  };

  handleJoinQuery = (query, page) => {
    const { perPage } = this.state;
    let joinQuery = query
      ? `${query}&limit=${perPage}&page=${page}`
      : `?limit=${perPage}&page=${page}`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    this.handleSyncUrlQuery(query, page);
    this.fetchData(joinQuery);
  };

  handleSyncUrlQuery = (query, page) => {
    const searchParams = new URLSearchParams(query || '');
    Array.from(searchParams.keys()).forEach((key) => {
      if (!searchParams.get(key)) {
        searchParams.delete(key);
      }
    });
    if (page > 1) {
      searchParams.set('page', page);
    }
    const search = searchParams.toString();
    this.props.router.navigate(
      { search: search ? `?${search}` : '' },
      { replace: true }
    );
  };

  handleFilterKeyword = (e) => {
    const parsedQuery = parseUrlQuery(e);
    this.setState({
      ...parsedQuery,
    });
    this.handleJoinQuery(parsedQuery.filterQuery, 1);
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...parseUrlQuery(''),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', 1);
  };

  handlePageClick = (e) => {
    const { filterQuery } = this.state;
    this.handleJoinQuery(filterQuery, e.selected + 1);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_REWARD_STOCK_HISTORY_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          e.stock_at
            ? moment(e.stock_at).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm')
            : '',
          e.reward_code,
          e.reward_name,
          RENDER_COUPON_TYPE(e.reward_type),
          RENDER_ACTION_TYPE(e.action_type),
          Number(e.amount || 0),
          Number(e.before_amount || 0),
          Number(e.after_amount || 0),
          e.admin_username || '',
          e.is_backfill ? 'ข้อมูลย้อนหลัง' : '',
          e.remark || '',
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        'No',
        'Date',
        'Reward code',
        'Reward Name',
        'Coupon Type',
        'Action',
        'Change (pcs)',
        'Total stock before',
        'Total stock after',
        'By',
        'Source',
        'Remark',
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      ws['!cols'] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 18 },
        { wch: 40 },
        { wch: 12 },
        { wch: 24 },
        { wch: 13 },
        { wch: 13 },
        { wch: 13 },
        { wch: 15 },
        { wch: 15 },
        { wch: 40 },
      ];
      XLSX.utils.book_append_sheet(wb, ws, 'stock movement');
      XLSX.writeFile(
        wb,
        `MISUMI stock movement ${moment()
          .tz(TIME_ZONE)
          .format('DD-MM-YYYY')}.xlsx`
      );
    }
    this.setState({
      isBgLoading: false,
    });
  };

  render() {
    const { isLoading, isBgLoading, pagination, data, filterValues, filterKey } =
      this.state;

    return (
      <StockMovementContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="filter_layout">
          <Inputs.InputFilter
            key={filterKey}
            theme_standard_input_filter
            dataFilter={dataFilter(filterValues)}
            btnLabel="ค้นหา"
            clearLabel="ล้างค่า"
            onQueryFilter={this.handleFilterKeyword}
            onClear={this.handleClearFilter}
            onExport={this.handleExport}
          />
        </div>
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="470px" />
        ) : (
          <Tables.Standard
            columns={columns}
            data={data}
            showPagination
            pagination={pagination}
            handlePageClick={this.handlePageClick}
          />
        )}
      </StockMovementContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'reward_name',
    length: '311px',
    filter: {
      fieldQuery: 'reward_name',
      type: 'text',
      defaultValue: filterValues.reward_name,
      label: 'Reward name : ',
      placeholder: 'Reward name',
    },
  },
  {
    accessor: 'reward_type',
    length: '311px',
    filter: {
      fieldQuery: 'reward_type',
      type: 'dropdown',
      defaultValue: filterValues.reward_type,
      options: [
        { label: 'All', value: '0' },
        { label: 'E-coupon', value: '1' },
        { label: 'Coupon', value: '2' },
        { label: 'Others', value: '3' },
      ],
      placeholder: 'Coupon type',
      label: 'Coupon type : ',
    },
  },
  {
    accessor: 'action_type',
    length: '311px',
    filter: {
      fieldQuery: 'action_type',
      type: 'dropdown',
      defaultValue: filterValues.action_type,
      options: [
        { label: 'All', value: '0' },
        { label: 'สร้างของรางวัล (portal)', value: '4' },
        { label: 'เพิ่มสต็อก (ไฟล์ reward)', value: '1' },
        { label: 'เพิ่มสต็อก (ไฟล์ e-coupon)', value: '2' },
        { label: 'แก้ไขสต็อก (portal)', value: '3' },
        { label: 'สต็อกหมด', value: '9' },
        { label: 'ปรับยอดแลกให้ตรงประวัติ', value: '8' },
      ],
      placeholder: 'Action',
      label: 'Action : ',
    },
  },
  {
    accessor: 'date',
    filter: {
      fieldQuery: 'date',
      type: 'dateRank',
      defaultStartValue: filterValues.start_date,
      defaultEndValue: filterValues.end_date,
      label: 'Date Range : ',
    },
  },
];

const columns = [
  {
    Header: <div style={{ textAlign: 'left' }}>Date</div>,
    accessor: 'stock_at',
    Cell: (props) =>
      props.value
        ? moment(props.value).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm')
        : '-',
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Reward Name</div>,
    accessor: 'reward_name',
    Cell: (props) => (
      <div>
        {props.value}
        {props.row.original.is_backfill && (
          <span className="backfill_tag">ย้อนหลัง</span>
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Coupon Type</div>,
    accessor: 'reward_type',
    Cell: (props) => RENDER_COUPON_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Action</div>,
    accessor: 'action_type',
    Cell: (props) => RENDER_ACTION_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Change (pcs)</div>,
    accessor: 'amount',
    Cell: (props) => {
      const amount = Number(props.value || 0);
      return (
        <div
          style={{ textAlign: 'right' }}
          className={amount > 0 ? 'amount_in' : amount < 0 ? 'amount_out' : ''}
        >
          {amount > 0 ? '+' : ''}
          {RenderCommaMoney(amount, true)}
        </div>
      );
    },
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Total stock before</div>,
    accessor: 'before_amount',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'right' }}>Total stock after</div>,
    accessor: 'after_amount',
    Cell: (props) => (
      <div style={{ textAlign: 'right' }}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>By</div>,
    accessor: 'admin_username',
    Cell: (props) => props.value || '-',
  },
];

export default withRouter(StockMovementContainer);
